import ReactLoading from 'react-loading';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { get } from 'lodash-es';
import { selectHouseRef } from '../../../selectors';
import { useAxios, useIsComponentMounted } from '../../../hooks';
import EditByInvoices from './EditByInvoice';
import EditByLot from './EditInvoices';

export const EditInvoices = () => {
  const [invoices, setInvoices] = useState([]);
  const [isByInvoice, setIsByInvoice] = useState();
  const [isProcessingData, setIsProcessingData] = useState(true);
  const { invoiceGroupID } = useParams();
  const houseRef = useSelector(selectHouseRef);
  const isComponentMounted = useIsComponentMounted();

  const { data, isIdle, isLoading } = useAxios(
    () => `/app/house/${houseRef}/invoiceGroup/${invoiceGroupID}/applyCostPerLot`,
    [houseRef]
  );

  const handleViewState = (flag) => {
    if (flag === false) {
      setIsByInvoice(true);
    }
  };

  const getData = () => {
    const invoiceData = get(data, 'data.data.invoiceBidders', []);
    if (invoiceData.length > 0) {
      handleViewState(invoiceData[0].applyCostPerLot);
      setInvoices(invoiceData);
      setIsProcessingData(false);
    }
  };

  useEffect(() => {
    if (typeof data === 'undefined' || data === null || !isComponentMounted.current) {
      return;
    }
    if (isComponentMounted.current && data !== null) {
      getData();
    }
  }, [data, isComponentMounted.current]);

  if (isIdle || isLoading || isProcessingData) {
    return (
      <ReactLoading className="loading-spinner" type="spin" color="black" />
    );
  }

  return (
    <>
      {isByInvoice && invoices ? <EditByInvoices /> : <EditByLot />}
    </>
  );
};
